export const filterCombinationsByColorAndSize = (
  results: any[],
  selectedColors: string[],
  selectedSizes: string[],
  selectedFeatures: string[],
) => {
  if (
    selectedColors.length === 0 &&
    selectedSizes.length === 0 &&
    selectedFeatures.length === 0
  ) {
    return results;
  }

  return results
    .map((product) => {
      const filteredCombinations = product.combinations.values.filter(
        (combination: any) => {
          const matchesColor =
            selectedColors.length === 0 ||
            selectedColors.includes(combination.attributes.Kolor);
          const matchesSize =
            selectedSizes.length === 0 ||
            selectedSizes.includes(combination.attributes.Rozmiar);

          return matchesColor && matchesSize;
        },
      );

      return {
        ...product,
        combinations: {
          ...product.combinations,
          values: filteredCombinations,
        },
      };
    })
    .filter((product) => product.combinations.values.length > 0);
};
